import clsx from 'clsx';
import styles from './styles.module.scss';

type IconButtonProps = {
  icon: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  alt?: string;
  iconWidth?: number | string;
  iconHeight?: number | string;
};

const IconButton: React.FC<IconButtonProps> = (props) => {
  const { icon, onClick, className, alt, iconHeight = 24, iconWidth = 24 } = props;

  return (
    <button
      tabIndex={-1}
      type='button'
      className={clsx(styles.button, className)}
      onClick={onClick}
    >
      <img alt={alt} src={icon} width={iconWidth} height={iconHeight} />
    </button>
  );
};

export default IconButton;
